import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "Creativo",
  icon: "✨",
  templates: [
    {
      title: "Cuento para Dormir",
      content: `Crea un cuento suave para dormir para un niño pequeño, escrito para ser leído en voz alta.
- El personaje principal es [un pequeño zorro amable] llamado [Avellana].
- La historia transcurre en [un acogedor pueblo del bosque donde las linternas brillan por la noche].
- El personaje enfrenta un pequeño desafío reconfortante: [no puede encontrar su estrella favorita en el cielo nublado, así que sigue a las luciérnagas hasta la cima de una colina].
- Termina con una resolución pacífica que enseña [la paciencia y a confiar en que las cosas buenas siguen ahí, incluso cuando no puedes verlas].
- Usa oraciones cortas y rítmicas que suenen naturales al leerlas en voz alta.`
    },
    {
      title: "Narración de Ficción Corta",
      content: `Escribe un cuento corto adecuado para narración estilo audiolibro.
- Género: [misterio contemporáneo].
- El protagonista es [una bibliotecaria jubilada que nota algo extraño en la rutina diaria del nuevo vecino].
- La tensión central son [pequeños detalles inexplicables que se acumulan hacia una revelación sorprendente pero satisfactoria].
- Tono: [suspenso tranquilo con toques de calidez].
- Escribe con un estilo claro y fluido, variando la longitud de las oraciones para mantener al oyente enganchado.`
    },
    {
      title: "Lectura de Poesía",
      content: `Escribe un poema pensado para ser recitado en voz alta.
- Tema: [la sensación de una ciudad despertando al amanecer].
- Estilo: [verso libre con un ritmo hablado natural].
- Estado de ánimo: [reflexivo y esperanzador].
- Incluye detalles sensoriales vívidos: [el sonido del primer autobús, la luz golpeando el pavimento mojado, el aroma del pan recién hecho de una panadería].
- Usa pausas y saltos de línea que guíen el ritmo y la respiración del lector.`
    }
  ]
};
